//预习任务
export const TASK_LIST = 'task_list';
export const TASK_INFO = 'task_info';
export const TASK_LIST_STUDENT = 'task_list_student';
export const COURSE_LIST = 'course_list'
export const PLAN_LIST = 'plan_list'
export const CLASS_LIST = 'class_list'
export const TREE_LIST = 'tree_list'
export const MESS_LIST = 'mess_list'
export const MESS_ADD = 'mess_add'
export const MESS_DEL = 'mess_del'
export const MESS_READ = 'mess_read'
export const TASK_TEST_STU = 'task_test_stu'
export const TASK_TEST_LIST = 'task_test_list'
export const EDIT_TASK_DATE = 'edit_task_date';



// WEBPACK FOOTER //
// ./src/store/yxTask/type.js